// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__1XzkJ","loadingShrink":"PageLoading_loadingShrink__e5AhH"};